export default __webpack_public_path__ + "static/media/shareEmail.6110cbb1.svg";